import { render, staticRenderFns } from "./MonitorDetail.vue?vue&type=template&id=6fa96328&scoped=true&"
import script from "./MonitorDetail.vue?vue&type=script&lang=js&"
export * from "./MonitorDetail.vue?vue&type=script&lang=js&"
import style0 from "./MonitorDetail.vue?vue&type=style&index=0&id=6fa96328&scoped=true&lang=css&"
import style1 from "./MonitorDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa96328",
  null
  
)

export default component.exports